export default () => ({
  unitToQuote: undefined,
  paymentMethods: [],
})
